import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { getTranslations } from '../Shared/translations';

interface ConfirmBoxProps {
  visible: boolean;
  message: string;
  closeBox: (visible: boolean) => void;
  confirmDelete: (idToDelete: number) => void;
  idToDelete: number
}

const ConfirmBox: React.FC<ConfirmBoxProps> = ({ visible, message, closeBox, confirmDelete, idToDelete }) => {
  const t = getTranslations();

  const handleClose = () => {
    closeBox(false);
  };

  const handleConfirm = () => {
    confirmDelete(idToDelete);
  };

  return (
    <Modal show={visible} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h1>{t.areYouSure}</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          {t.cancel}
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          {t.ok}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmBox;
